import { createApp } from "vue";
import App from "./App.vue";
import Bootstrap from "./assets/scss/custom.scss";
import VueRouter from "vue-router";

import Router from "./router";
import Modal from "../src/components/Modal.vue";

import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "vue-add-to-calendar";
import "add-to-calendar-button";

import vSelect from "vue-select";
import { install } from "vue3-recaptcha-v2";

const options = {
  timeout: 5000,
  theme: "bubble",
  position: "bottom-right",
  duration: 5000,
  keepOnHover: true,
};

const app = createApp(App)
  .use(Bootstrap)
  .use(VueRouter)
  .use(Router)
  .use(FloatingVue)
  .use(Toast, options)
  .use(install, {
    sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
    cnDomains: false,
  })
  .component("modal", Modal)
  .component("v-select", vSelect);

app.config.globalProperties.formatPhone = function (phone) {
  let rawPhone = phone.slice(3); // Remove o +55
  rawPhone = rawPhone.replace(/\D/g, ""); // Remove tudo que não for número
  // Força o +55
  if (rawPhone.length <= 0) {
    phone = `+55 `;
  } else if (rawPhone.length <= 2) {
    phone = `+55 ${rawPhone}`;
  } else {
    phone = `+55 ${rawPhone.slice(0, 2)} ${rawPhone.slice(2, 11)}`;
  }
  return phone;
};

app.mount("#app");
